module.exports = __webpack_public_path__ + "img/knzb-main.bfc7f685.jpg";